import React from 'react';
import {Bar, BarChart, ResponsiveContainer, XAxis, YAxis} from "recharts";
import {bbDoesCustomerHaveAccessToSubscription} from "../../../../util/bbHelpers";
import {useSelector} from "react-redux";
import Widget from "../../../prefabricated/Widget";

const AdminDashCustomerTypeChart = ({props}) => {

    const { customers, loadingCustomers, loadingCustomersError } = useSelector(({customer})=> customer);


    const findCustomersWithSubs= (subType)=> {
        if(loadingCustomersError){
            return null
        } else {
            const allCustomersArray = customers ? Object.values(customers) : null;

            const filterCustomersForSub = allCustomersArray
                && allCustomersArray
                    .filter((customer)=>{
                        return bbDoesCustomerHaveAccessToSubscription(customer, subType);
                    })

            return filterCustomersForSub && filterCustomersForSub.length;
        }
    }

    const findCustomersWithCIRT = (customers)=>{
        if(loadingCustomersError){
            return null
        } else {
            const allCustomersArray = customers ? Object.values(customers) : null;

            const filterCustomersForCIRT = allCustomersArray
                && allCustomersArray
                    .filter((customer)=>
                        customer.Stromboli && customer.Stromboli["Service Active"] === "1"
                    )

            return filterCustomersForCIRT && filterCustomersForCIRT.length;
        }

    }

    const data = [{name: "CIRT", value: findCustomersWithCIRT(customers) }, {name: "Business",value: findCustomersWithSubs(2) }, {name: "Portfolio", value: findCustomersWithSubs(1)}]

    return(
            <Widget styleName={`bg-secondary animated fadeIn animation-duration-5 dataTile`}>
                <div className="row">
                    <div className={"col-12"}>
                        <h1 className={"text-center text-white"}>Subscription Types</h1>
                    </div>
                </div>
                <div className="row align-self-center" style={{width: "100%"}}>
                    {/*<BarChart width={450} height={192} data={data}>*/}
                    {/*    <CartesianGrid strokeDasharray="2 2" />*/}
                    {/*    <XAxis dataKey={"name"} />*/}
                    {/*    <YAxis />*/}
                    {/*    <Bar dataKey="value" fill="#8884d8" />*/}
                    {/*</BarChart>*/}
                    <ResponsiveContainer height={150} minWidth={400}>
                        <BarChart layout={"vertical"} width={450} height={150} data={data}>*/}
                            {/*<CartesianGrid strokeDasharray="2 2" />*/}
                            <XAxis type={"number"} stroke={"white"}/>
                            <YAxis  type="category" dataKey={"name"} stroke={"white"}/>
                            <Bar dataKey="value" fill="#326a8c" label={{fill: "white", position: "end"}}/>
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </Widget>


    )
}

export default AdminDashCustomerTypeChart;


